import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "carPlay"
const CarPlayIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12.565 2C15.715 2 18.699 3.545 20.55 6.13L20.555 6.136C20.677 6.316 20.724 6.534 20.688 6.748S20.535 7.153 20.36 7.28 19.97 7.464 19.755 7.433C19.542 7.4 19.35 7.286 19.218 7.113L19.214 7.107 19.067 6.908C17.515 4.874 15.102 3.667 12.565 3.666 8.038 3.667 4.35 7.403 4.35 12S8.038 20.333 12.565 20.333C15.179 20.333 17.663 19.052 19.207 16.903L19.21 16.899C19.341 16.726 19.534 16.61 19.748 16.58S20.179 16.604 20.353 16.732C20.527 16.861 20.643 17.052 20.679 17.265S20.667 17.698 20.546 17.877L20.54 17.883C18.69 20.46 15.708 22 12.565 22 7.122 22 2.7 17.51 2.7 12S7.122 2 12.565 2" />
          <path
            fillRule="evenodd"
            d="M9.75 8.752C9.75 7.886 10.687 7.345 11.437 7.778L17.062 11.026 17.194 11.114C17.768 11.56 17.768 12.44 17.194 12.886L17.062 12.976 11.437 16.221C10.687 16.655 9.75 16.113 9.75 15.248zM11.25 14.6 15.75 12 11.25 9.401z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default CarPlayIcon
